export const messages = {
  noAuth: '您尚未登录',
  authBtn: '我要登录',
  error: '系统繁忙，小伙伴请稍后再试！',
  noData: '没有数据返回',
  noNet: '网络连接出问题了，请稍后重试！',
  tipbtn: '我知道了',
  btnConfirm: '确定',
  btnCancel: '取消',
  shareTitle: '优享免息商城',
  shareDesc: '分期不吃土，免息享购物'
};
export default {};
